import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { Config, User, Refresh } from '../models';

@Injectable()
export class ConfigService {
  private configSubject = new Subject<Config>();
  public config: Config;
  public config$ = this.configSubject.asObservable();
  constructor(private http: HttpClient) {
    this.populate();
  }

  // populates the config
  // This runs once on application startup
  populate() {
    this.config = <Config>window['guestIdentityConfig'];
    this.configSubject.next(this.config);
  }

  setConfig(config: Config) {
    this.configSubject.next(config);
    this.config = config;
  }

  getConfig(): Config {
    return this.config;
  }

  setUser(user: User) {
    const config = this.config;
    config.user = user;

    this.setConfig(config);
  }
}
